<template>
<span>
  <btn block type="success" @click="validate" :disabled="!enabled">
    Contrôler les fiches
  </btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>
      Fiches <span :class="`label label-${typeClass}`">{{ typeName }}</span>
    </h2>
    <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
</span>
</template>
<script>
import { mapState } from 'vuex'
import StepIterator from '@/sui/tools/stepiterator'
import validator from '@/sui/components/sheet/validate/impl/validator'
import steps from '@/sui/components/steps'
import types from '@/sui/data/modules'
import assert from '@/sui/tools/assert'

export default {
  name: 'validate-sheets',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    surveillance: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    sheets: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    const steps = [
      {
        title: 'Récupération des données',
        timeout: 10000,
        error: null,
        promise: true,
        progress: {
          value: 100
        },
        run: function (vm, data, iteration) {
          return vm.$store.dispatch(
            'sheet/full',
            {
              t: vm.type,
              sv: vm.surveillance.id,
              y: vm.surveillance.year,
              st: 'open'
            }
          ).then(
            (response) => {
              const { err, v } = response.data
              return {
                end: true,
                success: err == null && v != null,
                error: `${validator.msg.data}, ${validator.msg.verify}. ${validator.msg.persist}`
              }
            }
          )
        },

        setError: function () {
          this.error = `${validator.msg.data}, ${validator.msg.verify}. ${validator.msg.persist}`
        }
      },
      validator.steps.validate(vm => vm.fullList),
      validator.steps.statuses(vm => vm.type)
    ]

    return {
      show: false,
      enabled: !this.disabled,
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    ...mapState({
      full: state => state.sheet.full
    }),

    fullList: function () {
      return this.full[this.type]
    },

    typeClass: function () {
      return this.type
    },

    module: function () {
      return types.get(this.surveillance.year)[this.type]
    },

    typeName: function () {
      return this.module.name
    },

    reference: function () {
      assert.notNull(
        this.module,
        `selectReference: invalid sheet type (${this.module})`
      )

      return this.module.sheets.edit
    },

    completed: function () {
      return this.iterator.completed
    }
  },

  methods: {
    validate: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false

      const request = {
        t: this.type,
        s: this.surveillance.id,
        y: this.surveillance.year
      }
      const enable = () => { this.enabled = true }
      this.enabled = false
      this.$store.dispatch('sheet/load', request)
        .then(enable).catch(enable)
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
